/*eslint sort-keys: ["error", "asc", {caseSensitive: false}]*/

import { ENResources } from './en';

export const fr: Record<keyof ENResources, string> = {
  ban: 'Banni',
  close: 'Fermer',
  contact: 'Contact',
  contactDone: 'Merci pour votre message.',
  contactEmail: 'Email',
  contactMessage: 'Message',
  copy: 'Copier',
  create: 'Créer',
  defeat: 'DÉFAITE',
  donate: 'Donation',
  draftCreate: 'Partage la draft a tes amis',
  draftDescription: 'Créée une draft et partage-la a tes amis',
  draftList: 'Liste',
  draftLogs: 'Journal',
  draftSettingsCoin: 'Qui commence',
  draftSettingsMode: 'Cacher',
  draftSettingsTries: "Nombre d'essai",
  draftShareText: 'Salut, essaie de deviner cette draft #BSDrafting',
  fanContentPolicy: 'règlement de Supercell',
  fanContentPolicyLink: 'http://supercell.com/en/fan-content-policy/fr/',
  footer:
    "Ce contenu n'est pas officiel et n'a pas reçu le soutien de Supercell.\nPour plus d'informations, veuillez consulter le {FanContentPolicy}",
  guessLast: 'Dernier',
  guessTwoLast: 'Deux derniers',
  homeDescription:
    'Le site pour perfectionner vos compétences en draft sur Brawl Stars !\n\nCréez des compositions stratégiques et défiez vos amis pour deviner vos choix.\nAméliorez vos stratégies grâce à notre plateforme intuitive et devenez un expert en draft !',
  homeTitle: 'Bienvenue sur BS Drafting',
  listEmptyDescription: 'Allons créer votre premiere draft',
  listEmptyTitle: 'Pas encore de draft',
  listTeamShareText: 'Salut, essaie de deviner cette draft #BSDrafting',
  logsEmptyDescription:
    'Partages le site a tes amis et demandes-leur une draft',
  logsEmptyTitle: 'Pas encore de données',
  pick: 'Pris',
  share: 'Partager',
  submit: 'Envoyer',
  validate: 'Valider',
  victory: 'VICTOIRE',
};
